import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { ContentMobile } from './AlertCompMobile';
import { BlackFullWidthBtn, PaperBlurFitBtn } from '../../../shared/component/headless/button/BtnBody';
import { getBtnName } from '../../../shared/constants/btnNames';
import { slideInFromBottom } from '../../../shared/component/Animation';
import { MediumIcon } from '../../../shared/component/IconBody';
import logo from '../../../asset/gnb/logo_fit.png';
import { paperTextureMobile } from '../../../shared/component/paperTexture';
import { paddingBottomWithSafeArea } from '../../../shared/constants/safeArea';


const ConfirmCompMobile: React.FC = () => {
  const {
    queue,
    isClosing,
    isExecuting,
    executeCurrent,
    cancelCurrent,
  } = useStandardAlertStore();
  const alertRef = useRef<HTMLDivElement>(null);
  const currentStandardAlert = queue[0];

  useEffect(() => {
    if (alertRef.current) {
      alertRef.current.focus();
    }
  }, []);

  if (queue.length === 0) return null;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    if (event.key === 'Escape') {
      event.preventDefault();
      cancelCurrent();
      return;
    }
    if (event.target !== event.currentTarget) return;

    if (event.key !== 'Enter') return;
    event.preventDefault();
    cancelCurrent();
  };

  return (
    <ConfirmContentMobile ref={alertRef} onKeyDown={handleKeyDown} tabIndex={-1} $isClosing={isClosing}>
      <ConfirmHeaderMobile>
        <MediumIcon src={logo} alt='logo icon' />
      </ConfirmHeaderMobile>
      <ContentMobile>{currentStandardAlert.content}</ContentMobile>
      <ButtonContainer>
        {currentStandardAlert.callBack ?
          <>
            <BlackFullWidthBtn
              disabled={isClosing || isExecuting}
              onClick={() => void executeCurrent()}
            >
              {getBtnName('OK')}
            </BlackFullWidthBtn>
            <ButtonCancel
              disabled={isClosing || isExecuting}
              onClick={cancelCurrent}
            >
              {getBtnName('CANCEL')}
            </ButtonCancel>
          </>
          :
          <BlackFullWidthBtn
            disabled={isClosing || isExecuting}
            onClick={cancelCurrent}
          >
            {getBtnName('OK')}
          </BlackFullWidthBtn>
        }
      </ButtonContainer>
    </ConfirmContentMobile>
  );
};

const ConfirmHeaderMobile = styled.div`
  margin: 6px 0px 12px 0px;
  user-select: none;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;


const ButtonCancel = styled(PaperBlurFitBtn)`
  width: 100%;
`;

const ConfirmContentMobile = styled.div<{ $isClosing: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: fit-content;
  min-height: 24vw;

  padding: 20px 20px ${paddingBottomWithSafeArea('20px')} 20px;
  outline: none;
  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateY(100%)'
      : 'translateY(0)'
  };
  transition: all 0.5s ease-out;
  ${paperTextureMobile}
  background-color: ${({ theme }) => theme.colors.color_White};
  ${slideInFromBottom}
`;

export default ConfirmCompMobile;
